import { render, staticRenderFns } from "./Quizzes.vue?vue&type=template&id=9e36e034&"
import script from "./Quizzes.vue?vue&type=script&lang=js&"
export * from "./Quizzes.vue?vue&type=script&lang=js&"
import style0 from "./Quizzes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports